import React from "react";
import logo from "../asset/SMG Logo.png";
import "../css/footer.css";
import { Link } from "react-router-dom"; // For React Router navigation
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <div>
      <section id="footer">
        <div className="container">
          <div className="row">
            {/* Left Column: Logo and About */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 text-center">
                  <img src={logo} alt="Footer Logo" className="ftr-logo " />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <p className="ftr-para">
                    Founded in 1993 by the visionary Shri. Maruti U. Gaikar, SMG
                    English School proudly stands as the first English medium
                    school in Diva, setting a golden standard in education.
                    Operating under the esteemed Om Sai Shikshan Sanstha since
                    1998, SMG began its mission with just 36 pre-primary
                    students in Dativali village. Today, it has flourished into
                    a beacon of academic excellence and holistic development.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Contact Information */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h5 className="footer-heading">Contact Us</h5>
              <div className="contact-info">
                <h6 className="schoolname">SMG Vidyamandir & Junior College</h6>
                <p>Dativali, Diva Agasan Road, Diva (E), Dist. Thane</p>
                <p>
                  <strong>Tel:</strong> +91 9594 930 307
                </p>
                <p>
                  <strong>Email:</strong> smgthane@gmail.com
                </p>
              </div>

              <div className="contact-info">
                <h6 className="schoolname">SMG Vidyalay & Junior College</h6>
                <p>Sonarpada, Lalit Kata, Dombivli (E), Dist. Thane</p>
                <p>
                  <strong>Tel:</strong> +91 8976 666 266
                </p>
                <p>
                  <strong>Email:</strong> smgdombivali@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div>
                © Copyright 2024 All rights reserved by SMG Vidyamandir & Jr.
                College.
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 footer-links-container">
              <Link className="footer-link faq" to="/faq">
                FAQ
              </Link>

              <span className="footer-link separator">|</span>
              <div className="social-links">
                <Link
                  className="footer-link social"
                  to="https://www.facebook.com/p/SMG-Vidyamandir-Junior-College-100064053671020/"
                >
                  <FaFacebook />
                </Link>
                <Link
                  className="footer-link social"
                  to="https://www.instagram.com/smgvidyamandir/"
                >
                  <FaInstagram />
                </Link>
                <Link
                  className="footer-link social"
                  to="https://www.youtube.com/@smgvidyamandir"
                >
                  <FaYoutube />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
